import { z } from 'zod';
import { toNumber } from '../../Utility';
import { isNullish, Nullish } from '../../Utility/Nullish';

/**
 * @throws ZodError if marshalled value is `NaN`.
 */
export function zMarshalToNumber(val: string | number, ctx: z.RefinementCtx): number {
    const parsed = toNumber(val);
    if (isNaN(parsed)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Not a number',
        });
        return z.NEVER;
    }
    return parsed;
}

/**
 * @throws ZodError if marshalled value is `NaN`.
 */
export function zMarshalToNumberNullable(
    val: string | number | Nullish,
    ctx: z.RefinementCtx
): number | null {
    return isNullish(val) ? null : zMarshalToNumber(val, ctx);
}
